import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Search,  User } from 'lucide-react';

import authAPI from '../../services/api';

export default function AgricExpertsList() {
  
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [specializations, setSpecializations] = useState([]);

  // Fetch experts from API
  useEffect(() => {
    const fetchExperts = async () => {
      try {
        setLoading(true);
        const response = await authAPI.getExperts();
        if (response.success) {
          setExperts(response.data);
          // Extract unique specializations for filter tabs
          const uniqueSpecializations = [...new Set(response.data.map(expert => expert.specialization))];
          setSpecializations(uniqueSpecializations);
        } else {
          setError('Failed to fetch experts');
        }
      } catch (err) {
        console.error('Error fetching experts:', err);
        setError('Failed to load experts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchExperts();
  }, []);

  const filteredExperts = experts.filter(expert => {
    const matchesTab = activeTab === 'all' || 
                      expert.specialization.toLowerCase().includes(activeTab.toLowerCase());
    const matchesSearch = expert.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         expert.specialization.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });

  if (loading) {
    return (
      <div className="experts-container">
        <div className="header-txt">
          <h1>Agricultural Experts</h1>
          <p>Connect with certified professionals for farming advice</p>
        </div>
        <div className="loading-state">
          <p>Loading experts...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="experts-container">
        <div className="header-txt">
          <h1>Agricultural Experts</h1>
          <p>Connect with certified professionals for farming advice</p>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="experts-container">
      <div className="header-txt">
          <h1>Agricultural Experts</h1>
        <p>Connect with certified professionals for farming advice</p>
        </div>
     

      <div className="experts-controls">
      <div className="search-wrapper-app">
          <div className="search-icon-app">
            <Search size={18} />
          </div>
          <input
            type="text"
            className="search-input-app"
            placeholder="Search experts..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

   {/*      <div className="filter-tabs">
          <button 
            className={activeTab === 'all' ? 'active' : ''}
            onClick={() => setActiveTab('all')}
          >
            All Experts
          </button>
          {specializations.map(specialization => (
            <button 
              key={specialization}
              className={activeTab === specialization ? 'active' : ''}
              onClick={() => setActiveTab(specialization)}
            >
              {specialization}
            </button>
          ))}
        </div> */}
      </div>

      {filteredExperts.length === 0 ? (
        <div className="no-experts">
          <p>No experts found matching your criteria.</p>
        </div>
      ) : (
        <div className="experts-grid">
          {filteredExperts.map(expert => (
            
            <Link
              to={`/farmer-dashboard/experts/${expert.expert_id}`} 
             key={expert.expert_id} 
             className="expert-card">
              <div className="card-image">
                {expert.image ? (
                  <img src={expert.image} alt={expert.name} />
                ) : (
                  <div className="no-image-placeholder">
                    <User size={60} color="#999" />
                  </div>
                )}
                <div className="expert-card-ct">
                  <h2>{expert.name}</h2>
                  <p>{expert.specialization}</p>
                </div>
              </div>
            
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}